import React, {useRef} from "react";
import {FieldWithLabel} from "../../../hoc/withClass";
import {useTypedSelector} from "../../../redux/Hooks/storeSelectors";
import {selectRoadRouteCheckerPoint,} from "../../../redux/selectors/selectors";
import '../GeometryField/geometry-form-field.scss';
import classNames from "classnames";
import {useTheme} from "../../../context/themeContext";
import {FormFieldProps} from "../Form/Form";
import {MarkerPoint} from "../../../redux/road-route-check/types";


type Props = {
    label?: string;
    name: string;
    defaultCoordinates: MarkerPoint;
} & FormFieldProps;

const MapMarkerField = ({name, defaultCoordinates}: Props) => {
    const ref = useRef<any>(null);
    const point = useTypedSelector((state) => selectRoadRouteCheckerPoint(state, name));
    const {theme} = useTheme();

    const className = classNames(
        'text-field-md',
        theme
    );

    return (
        <div className="geometry-form-field" style={{flexGrow: 0}}>
            <input
                name={name}
                type="text"
                value={JSON.stringify(point ?? defaultCoordinates)}
                hidden
                readOnly
                ref={ref}
            />
        </div>
    )
}

const Labeled = FieldWithLabel<Props>(MapMarkerField);

export {Labeled, MapMarkerField}